export const environment = {
  production: true,
  // apiEndpoint: 'https://beta.convis.statlabs.io',
  apiEndpoint: 'https://dev-convis.mhealth-lab.com',
  convexURL: 'https://dev-convex.mhealth-lab.com'
};
